import { LocationOption } from 'modules/locations/domain/interfaces/location';
import { LocationOptionResponseDto } from 'modules/locations/domain/interfaces/response-dto';

export function locationsToOptions(locations: LocationOptionResponseDto[]): LocationOption[] {
  if (!locations) return [];
  if (locations.length === 0) return [];

  return locations.map((location) => ({
    value: location.id,
    label: location.name ?? 'Неизвестная локация',
  }));
}
